import { OrgAuthMethods } from 'api/AuthenticationPolicyAPI';
import { Member } from './types';

export const fullName = (member: Member) => `${member.firstName} ${member.lastName}`;

export const isMfaAvailable = ({ googleAuthEnabled, userPassAuthEnabled }: OrgAuthMethods) =>
  googleAuthEnabled || userPassAuthEnabled;
